import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { Wrench, FileText, Bell, Loader2 } from "lucide-react";

export default function EquipmentLogViewPage() {
  const { logId } = useParams();
  const [log, setLog] = useState(null);
  const [state, setState] = useState("loading"); // loading | ok | error

  useEffect(() => {
    axios.get(`${API}/equipment-logs/${logId}`)
      .then(({ data }) => { setLog(data); setState("ok"); })
      .catch(() => setState("error"));
  }, [logId]);

  if (state === "loading") {
    return <div className="min-h-screen flex items-center justify-center bg-zinc-50"><Loader2 className="w-8 h-8 animate-spin text-[#00341d]" /></div>;
  }
  if (state === "error") {
    return <div className="min-h-screen flex items-center justify-center bg-zinc-50 text-gray-500">Log not found.</div>;
  }

  return (
    <div className="min-h-screen bg-zinc-50" data-testid="equipment-log-view">
      <header className="bg-[#00341d] text-white">
        <div className="max-w-2xl mx-auto px-6 py-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-300 flex items-center gap-2">
            <Wrench className="w-4 h-4" /> {log.equipment_name || "Equipment"}
          </p>
          <h1 className="font-heading text-3xl font-bold mt-2">{log.headline}</h1>
          <p className="text-emerald-100/80 mt-2 text-sm">{new Date(log.created_at).toLocaleString()}</p>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-8 space-y-6">
        <div className="flex gap-6 text-sm">
          {log.hours != null && <div><div className="text-gray-400 uppercase text-xs font-bold">Hours</div><div className="text-lg font-semibold">{log.hours}</div></div>}
          {log.miles != null && <div><div className="text-gray-400 uppercase text-xs font-bold">Miles</div><div className="text-lg font-semibold">{log.miles}</div></div>}
        </div>

        {log.notes && (
          <div>
            <div className="text-gray-400 uppercase text-xs font-bold mb-1">Notes</div>
            <p className="text-gray-800 whitespace-pre-wrap leading-relaxed">{log.notes}</p>
          </div>
        )}

        {log.attachments?.length > 0 && (
          <div>
            <div className="text-gray-400 uppercase text-xs font-bold mb-2">Attachments</div>
            <div className="flex flex-wrap gap-3">
              {log.attachments.map((a) => a.is_image ? (
                <a key={a.id} href={a.url} target="_blank" rel="noreferrer">
                  <img src={a.url} alt={a.filename} className="w-28 h-28 rounded-lg object-cover border" />
                </a>
              ) : (
                <a key={a.id} href={a.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 rounded-lg border px-3 py-2 text-sm text-gray-700 bg-white">
                  <FileText className="w-4 h-4" /> {a.filename}
                </a>
              ))}
            </div>
          </div>
        )}

        {log.reminder?.enabled && (
          <div className="flex items-center gap-2 text-sm text-[#00341d] border-t pt-4">
            <Bell className="w-4 h-4" /> Reminder: {log.reminder.name} · {log.reminder.date}
          </div>
        )}
      </main>
    </div>
  );
}
